/**
 * Various dropdown options for the profile form
 * Includes experience levels, availability options, payment preferences, and venue types
 */

// Experience levels for artists
export const experienceLevels = [
  'Beginner',
  'Intermediate',
  'Advanced',
  'Professional',
  'Expert',
  'Hobbyist',
  'Student',
  'Teacher',
  'Semi-Professional',
  'Touring Professional',
  'Studio Professional',
  'Session Musician',
  'Orchestral Musician',
  'Conservatory Trained',
  'Self-Taught',
];

// Availability options for artists
export const availabilityOptions = [
  'Weekday Evenings',
  'Weekday Afternoons',
  'Weekday Mornings',
  'Weekend Evenings',
  'Weekend Afternoons',
  'Weekend Mornings',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
  'Full-Time',
  'Part-Time',
  'Seasonal',
  'Summer Only',
  'Winter Only',
  'Holidays',
  'Special Events',
  'Short Notice',
  'Advance Booking Required',
  'Touring Available',
  'Local Gigs Only',
  'Remote Sessions',
  'Studio Sessions',
  'Live Performances',
  'Corporate Events',
  'Private Parties',
  'Weddings',
];

// Payment preferences for artists
export const paymentPreferences = [
  'Hourly Rate',
  'Fixed Fee Per Gig',
  'Revenue Share',
  'Tips Only',
  'Negotiable',
  'Minimum Guarantee + Tips',
  'Per Song/Composition',
  'Per Session',
  'Weekly Rate',
  'Monthly Retainer',
  'Royalties',
  'Trade/Barter',
  'Free (Exposure/Portfolio Building)',
  'Free (Charitable Events)',
  'Sliding Scale',
  'Union Rates',
  'Ticket Sales Percentage',
  'Merchandise Sales Percentage',
  'Direct Deposit',
  'Cash Only',
  'Check',
  'PayPal',
  'Venmo',
  'Cash App',
  'Cryptocurrency',
];

// Venue types
export const venueTypes = [
  'Bar',
  'Nightclub',
  'Concert Hall',
  'Theater',
  'Arena',
  'Stadium',
  'Amphitheater',
  'Restaurant',
  'Café',
  'Coffee Shop',
  'Brewery',
  'Winery',
  'Distillery',
  'Hotel',
  'Resort',
  'Casino',
  'Wedding Venue',
  'Event Space',
  'Art Gallery',
  'Museum',
  'Community Center',
  'Church/Religious Space',
  'School/University',
  'Library',
  'Park',
  'Public Square',
  'Street Performance Area',
  'Festival Grounds',
  'Fair Grounds',
  'Private Residence',
  'Corporate Space',
  'Recording Studio',
  'Rehearsal Space',
  'Pop-up Venue',
  'Virtual/Online Platform',
];
